/* global moment */
angular
  .module('statWdressroom')
  .component('statWdressroom', {
    template: require('./stat-wdressroom.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatWressroomController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'wdressroom';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.isLoading = true;
        this.from_date = moment().startOf('month').format('YYYY-MM-DD');
        this.to_date = moment().endOf('month').format('YYYY-MM-DD');
        this.tbUserIdEmployee = '-1';

        const promiseWashCountByWDressRoom = () => $resource(`${APIURL}/admin/stat/wash/counts/wroomdress`).get({ from_date: this.from_date, to_date: this.to_date, tbUserIdEmployee: this.tbUserIdEmployee }).$promise.then((data) => {
          this.washByWroomDressCount = data.washByWroomDressCount;
          this.optionWDressRoom = data.optionWDressRoom;
        });

        $scope.reload = () => {
          this.isLoading = true;
          const promises = [promiseWashCountByWDressRoom()];
          Promise.all(promises).then(() => {
            console.log('loading completed');
            this.isLoading = false;
            $scope.$apply();
          })
            .catch((err) => {
              console.error(err);
              this.isLoading = false;
              $scope.$apply();
            });
        };

        $scope.onDatePick = () => {
          console.log('onDatePick');
          this.from_date = jQuery('#inputPickerFrom').val();
          this.to_date = jQuery('#inputPickerTo').val();
          $scope.reload();
        };

        $scope.reload();

        // fetch employee list
        $resource(`${APIURL}/admin/employees`).get({ count: 10000, include_unregister: false }, (data) => {
          $scope.employees = data.users;
        }, (err) => {
          console.error(err);
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-wdressroom/stat-wdressroom.component.js